// extracted by mini-css-extract-plugin
export var buttonContainer = "styles-module--buttonContainer--2d6e1";
export var example = "styles-module--example--f94b7";
export var exampleItems = "styles-module--exampleItems--3d88d";
export var examples = "styles-module--examples--b82f1";
export var textContent = "styles-module--textContent--2947a";
export var title = "styles-module--title--74d96";